import { cloneDeep } from "lodash";
export function getResetState(initialState) {
    return (function (state) {
        var newInitialState = cloneDeep(initialState);
        for (var key in state) {
            state[key] = newInitialState[key];
        }
    });
}
//# sourceMappingURL=resetState.js.map